/**
 * Default request headers plus a call's own, merged case-insensitively: a per-call header REPLACES the default of the
 * same name. Spreading two plain objects kept 'Content-Type' and 'content-type' as separate keys, fetch() joined them
 * into "application/json, application/json", and the server did not parse the JSON body (gold labels → 400).
 *
 * Returns a plain object (lower-case names), not a `Headers` instance: the SSO SDK's `apiFetch` adds the bearer token
 * with `{ ...init.headers, Authorization }`, and spreading a `Headers` instance yields `{}`.
 */
export function mergeRequestHeaders(defaults: Record<string, string>, extra?: HeadersInit): Record<string, string> {
  const headers = new Headers(defaults);
  if (extra) new Headers(extra).forEach((value, key) => headers.set(key, value));
  return Object.fromEntries(headers.entries());
}
